import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js'
import { Line } from 'react-chartjs-2'
import type { ReleaseBandsData, TrafficData } from '../../lib/types'
import {
  createReleaseBandsPlugin,
  ReleaseBandsLegend,
} from './release-bands'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
)

interface TrafficOverviewChartProps {
  data: TrafficData
  releaseBands?: ReleaseBandsData
}

export function TrafficOverviewChart({
  data,
  releaseBands = [],
}: TrafficOverviewChartProps) {
  const periods = data.map((d) => d.period)
  const chartData = {
    labels: periods.map((period) => {
      const date = new Date(period)
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
      })
    }),
    datasets: [
      {
        label: 'Page Views',
        data: data.map((d) => d.page_views),
        borderColor: 'hsl(222.2, 47.4%, 11.2%)',
        backgroundColor: 'hsla(222.2, 47.4%, 11.2%, 0.1)',
        fill: true,
        tension: 0.3,
      },
      {
        label: 'Unique Visitors',
        data: data.map((d) => d.unique_visitors),
        borderColor: 'hsl(215.4, 16.3%, 46.9%)',
        backgroundColor: 'hsla(215.4, 16.3%, 46.9%, 0.1)',
        fill: true,
        tension: 0.3,
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: 'hsl(214.3, 31.8%, 91.4%)',
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
    interaction: {
      intersect: false,
      mode: 'index' as const,
    },
  }

  return (
    <div className="space-y-3">
      <ReleaseBandsLegend releaseBands={releaseBands} />
      <div className="h-[300px]">
        <Line
          data={chartData}
          options={options}
          plugins={[createReleaseBandsPlugin(periods, releaseBands)]}
        />
      </div>
    </div>
  )
}
